module.exports = __webpack_public_path__ + "img/12.cd471c41.png";